import { createContext } from 'react';

var IndexContext = createContext(null);

export { IndexContext };
